export default __webpack_public_path__ + "static/media/flexibel_zijn.351e39bf.jpg";